<template>
  <div class="side_box" :style="style">
    <div>
      <label for="lotnumber">Lot number</label>
      <span v-if="this.details">{{this.details.lotAssemblyID}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="ref">REF</label>
      <span v-if="this.details">{{this.details.ref}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="subparts">Subparts</label>
      <span v-if="this.details">{{this.details.subpartCount}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="description">Description</label>
      <span v-if="this.details">{{this.details.description}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="quantity">Quantity</label>
      <span v-if="this.details">{{this.details.amount}}</span>
      <span v-else>...</span>
    </div>
    <router-link v-if="this.details.lotID != ''" class="dhr-link text" :to="'/production/dhr/' + this.details.DHRID + '/' + this.details.lotAssemblyID">View full DHR</router-link>
  </div>
</template>

<script>
export default {
  computed: {
    style() {
      return 'height: ' + this.height + '%';
    }
  },
  props: {
    height: String,
    details: Object
  },
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";

.side_box {
  max-height: 440px;
}


.dhr-link {
  font-size: 12px;
  display: block;
  font-weight: 500;
  color: #035362;
  text-decoration: underline !important;

  position: absolute;
  top: 20px;
  right: 20px;
}

h4 {
  width: 100%;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 16px;
  text-align: left;
  color: #035362;
  text-transform: uppercase;
}
</style>
